import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = { class: "truncate flex-1" }
const _hoisted_3 = {
  key: 0,
  class: "text-body2 font-bold bg-white rounded-full border border-green ml-1 px-2 h-6 min-w-6 flex items-center justify-center"
}

import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  text: {
    type: String,
    default: undefined,
  },
  count: {
    type: [String, Number],
    default: undefined,
  },
  hideZeroCount: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props



// If we want to hide the chip when the count is 0 then hide if null/undefined/0. Else only hide if null/undefined.
const showCount = computed(() => props.hideZeroCount ? props.count : (props.count !== null && props.count !== undefined))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "flex flex-1 no-wrap items-center",
    title: __props.text
  }, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(__props.text), 1),
    (_unref(showCount))
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.count), 1))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ], 8, _hoisted_1))
}
}

})